import React, { FC } from 'react';

import { IconContainer, StyledLineStatusChip } from './LineStatusChip.styles';
import { AllieText } from '../../../components';
import {
  AllieCheckmarkCicleOutlineIcon,
  AllieTool,
  AllieLinkBrokenIcon,
  AllieSlashIcon,
} from '../../../styling/icons';

export const AllieLineStatusChip: FC<{ lineStatus: string; text: string }> = ({
  lineStatus,
  text,
}) => {
  if (lineStatus === 'ACTIVE') {
    return (
      <StyledLineStatusChip
        color={{
          backgroundColor: 'success-5',
          borderColor: 'success-60',
          allieColor: 'success-70',
        }}
        radius="sm"
      >
        <AllieText type="body3" weight={500} color="success-70">
          {text}
        </AllieText>
        <IconContainer color="success-70">
          <AllieCheckmarkCicleOutlineIcon display="flex" />
        </IconContainer>
      </StyledLineStatusChip>
    );
  }

  if (lineStatus === 'PENDING_ACTIVATION') {
    return (
      <StyledLineStatusChip
        color={{
          backgroundColor: 'warning-5',
          borderColor: 'warning-20',
          allieColor: 'warning-70',
        }}
        radius="sm"
      >
        <AllieText type="body3" weight={500} color="warning-70">
          {text}
        </AllieText>
        <IconContainer color="warning-70">
          <AllieTool display="flex" />
        </IconContainer>
      </StyledLineStatusChip>
    );
  }

  if (lineStatus === 'SUSPENDED') {
    return (
      <StyledLineStatusChip
        color={{
          backgroundColor: 'neutral-5',
          borderColor: 'neutral-20',
          allieColor: 'neutral-70',
        }}
        radius="sm"
      >
        <AllieText type="body3" weight={500} color="neutral-70">
          {text}
        </AllieText>
        <IconContainer color="neutral-70">
          <AllieLinkBrokenIcon display="flex" />
        </IconContainer>
      </StyledLineStatusChip>
    );
  }

  if (lineStatus === 'DISABLE') {
    return (
      <StyledLineStatusChip
        color={{
          backgroundColor: 'error-5',
          borderColor: 'error-20',
          allieColor: 'error-70',
        }}
        radius="sm"
      >
        <AllieText type="body3" weight={500} color="error-70">
          {text}
        </AllieText>
        <IconContainer color="error-70">
          <AllieSlashIcon display="flex" />
        </IconContainer>
      </StyledLineStatusChip>
    );
  }

  return null;
};
